import React, { Component } from 'react';
import PreLoaderWidget from '../../../components/Loader';
import Notificacao from '../../../components/Notificacao';
import Loading from '../../../components/Loading';
import { Row, Col } from 'reactstrap';
import moment from 'moment';
import { Editor } from "@tinymce/tinymce-react";
import IconCID from '../../../assets/images/wheelchair_32px.png';
import SelectIcon from '../../../gb-components/SelectIcon'
import { setAuditoriaMaterial } from '../../../Libs/paciente';
import {
  firebaseStorage,
  firebaseFire
} from "../../../helpers/firebase-config";
import { AuditoriaStatus } from '../../../helpers/enums';
import HeaderModal from '../../../gb-components/HeaderModal';


export default class CadastrarAuditoria extends Component {
  inputReceitaRef = React.createRef();
  inputAnexosRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      receita: "",
      outrosAnexos: [],
      descricao: "",
      tipoMaterial: "",
      materiais: ["Ortopédico"]
    };

    this.onAddReceitaClick = this.onAddReceitaClick.bind(this);
    this.onAddAnexosClick = this.onAddAnexosClick.bind(this);
    this.uploadTaskPromise = this.uploadTaskPromise.bind(this);
  }

  componentDidMount() {
    const hasAuditoria = this.props.auditoria
    if (hasAuditoria) {
      this.setState({
        tipoMaterial: hasAuditoria.tipoMaterial,
        receita: hasAuditoria.receita,
        outrosAnexos: hasAuditoria.outrosAnexos,
        descricao: hasAuditoria.descricao,
      })
    }
  }

  async uploadTaskPromise(uploadTask) {
    return new Promise(function (resolve, reject) {
      uploadTask.on('state_changed',
        function (snapshot) {
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          console.log('Upload is ' + progress + '% done')
        },
        function error(err) {
          console.log('error', err)
          reject()
        },
        function complete() {
          uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
            resolve(downloadURL)
          })
        }
      )
    })
  }

  _setCadastro = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    const {
      receita,
      outrosAnexos,
      descricao,
      tipoMaterial,
    } = this.state;

    //valida os campos
    let erros = []
    if (!tipoMaterial || tipoMaterial === "") {
      erros.push("Selecione o tipo de material")
    }

    if (!descricao || descricao === "") {
      erros.push("Descreva a solicitação")
    }

    if (outrosAnexos.length === 0) {
      erros.push("Informe ao menos um anexo! Exemplo: radioagrafias, orçamentos. etc.")
    }

    if (receita === "") {
      erros.push("Adicione a receita médica")
    }

    if (erros.length > 0) {
      this.setState({
        loading: false,
        notifition: true,
        msg: erros.join("<br />"),
        nameclass: 'alert-danger'
      });
      return;
    }

    const refProfissional = this.props.profissional.ref
    let receitaDB = "";
    let anexosDb = [];


    if (!this.props.editing) {
      const receitaFileName = `${moment().format('YYYY-MM-DD_HH:mm:ss')}_${this.props.idPaciente}_${receita.name}`
      const uploadReceita = firebaseStorage
        .ref()
        .child('auditoria_material')
        .child(receitaFileName)
        .put(receita)

      receitaDB = await this.uploadTaskPromise(uploadReceita);

      for (let index = 0; index < outrosAnexos.length; index++) {
        const anexoAux = outrosAnexos[index];
        // var anexoExt = anexoAux.type.contains("pdf") ? ".pdf" : ".jpg"
        const fileName = `${moment().format('YYYY-MM-DD_HH:mm:ss')}_${this.props.idPaciente}_${anexoAux.name}`

        const uploadAnexo = firebaseStorage.ref()
          .child('auditoria_material')
          .child(fileName)
          .put(anexoAux)

        const uploaded = await this.uploadTaskPromise(uploadAnexo);
        anexosDb.push(uploaded);
      }

      const data = {
        tipoMaterial,
        descricao,
        receita: receitaDB,
        outrosAnexos: anexosDb,
        created_at: moment().format('YYYY-MM-DD HH:mm'),
        refProfissional,
        status: AuditoriaStatus.Aguardando,
        comentarios: []
      };

      await firebaseFire.collection("paciente")
        .doc(this.props.idPaciente)
        .update({
          'status_auditoria_material': AuditoriaStatus.Aguardando
        })


      setAuditoriaMaterial(data, this.props.idPaciente)
        .then(dcc => {
          this.close()
        })
        .catch(erro => {
          this.setState({
            loading: false,
            notifition: true,
            msg: erro.code,
            nameclass: 'alert-danger'
          });
        });
    } else {
      await this.props.auditoria.ref.update({ descricao: descricao })
      this.close()
    }

  };

  close() {
    this.setState({ isVisibleSend: false });
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  onAddReceitaClick() {
    this.inputReceitaRef.current.click();
  };

  onAddAnexosClick() {
    this.inputAnexosRef.current.click();
  };

  setReceita(e) {
    if (e.target.files && e.target.files.length > 0) {
      this.setState({ receita: e.target.files[0] })
    }
  }

  setOutrosAnexos(e) {
    if (e.target.files && e.target.files.length > 0) {
      this.setState({ outrosAnexos: [e.target.files[0], ...this.state.outrosAnexos] })
    }
  }

  render() {
    return (
      <div className="p-3">
        <HeaderModal title={this.props.editing ? "Editar auditoria" : "Nova auditoria"} />
        <Loading loading={this.state.loading} />

        {this.state.notifition ? (
          <Notificacao
            msg={this.state.msg}
            nameclass={this.state.nameclass}
          />
        ) : null}

        <form onSubmit={(e) => this._setCadastro(e)}>
          <Row>
            <Col md={12}>
              <SelectIcon
                placeholder="Material"
                data={this.state.materiais ?
                  this.state.materiais.map((item, index) => {
                    return { id: item, descricao: item }
                  }) : []}
                value={this.state.tipoMaterial}
                icon={IconCID}
                change={event => {
                  console.log(event.target.value);
                  this.setState({ tipoMaterial: event.target.value })
                }}
                label={"Material"}
                style={{ width: '100%', marginBottom: '10px' }}
              />
              <Editor
                onEditorChange={e => this.setState({ descricao: e })}
                value={this.state.descricao}
                apiKey="jl2uw5yob5e4avhldqg1sm0npw0zkdayoz2xj4wwgr2lj1ei"
                init={{
                  language: 'pt_BR',
                  height: 250,
                  placeholder: "Descreva sua solicitação",
                  toolbar: "undo redo | fontselect fontsizeselect | bold italic underline forecolor backcolor | align lineheight checklist bullist numlist",
                  browser_spellcheck: true,
                }}
              ></Editor>
            </Col>
          </Row>

          <Row className='mb-2 mt-2'>
            <Col md={4}>
              <input
                hidden
                type='file'
                accept="image/*,application/pdf"
                ref={this.inputReceitaRef}
                onChange={(e) => { this.setReceita(e) }}
              />
              <button
                type='button'
                className='btn gb-button mr-2' onClick={this.onAddReceitaClick}>Adicionar Receita</button>
              {this.state.receita && this.state.receita !== "" &&
                <React.Fragment>
                  {/* <img src={URL.createObjectURL(this.state.receita)} width="150"></img> */}
                  {this.state.receita.name ?
                    <p className='mb-1 mt-1'>{this.state.receita.name}</p> :
                    <a href={this.state.receita} target='_blank'><i className='fa fa-file-download'></i></a>
                  }
                </React.Fragment>
              }
            </Col>
            <Col md={8}>
              <input
                hidden
                type='file'
                accept="image/*,application/pdf"
                ref={this.inputAnexosRef}
                onChange={(e) => { this.setOutrosAnexos(e) }}
              />
              <div className='d-flex'>
                <button
                  type='button'
                  className='btn gb-button mr-2'
                  onClick={this.onAddAnexosClick}
                >Adicionar Anexos</button>
                <p className='mb-1 mt-1'>Exemplo: Radiografias, Orçamentos de materias, etc.</p>
              </div>

              {this.state.outrosAnexos && this.state.outrosAnexos.length > 0 ?
                <React.Fragment>
                  {this.state.outrosAnexos.map((a, i) => {
                    return (
                      /*  <img key={i} src={URL.createObjectURL(a)} width="150"></img> */
                      <p key={i} className='mt-1'>{a.name}</p>
                    )
                  })}
                </React.Fragment>
                : null
              }
            </Col>
          </Row>

          <div className="mt-3">
            <div>{this.state.loading ? (<PreLoaderWidget></PreLoaderWidget>) : <button
              type="submit"
              className="btn gb-button to-form full"
              disabled={this.state.loading}
            >
              Salvar
            </button>}
            </div>
          </div>

        </form>
      </div>
    );
  }
}
